import { Button } from '@components/button';
import { createForm } from '@components/form';
import { IconAddPlus } from '@components/icons/add-plus';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { disabledSectionStyle } from '@styles/theme';

import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

import { EditCosigner, useAddDokobitCosigner } from './api';

const Form = createForm<EditCosigner>();

export const DokobitCosignerModal = ({ closeModal }: ModalProps) => {
  const { t } = useStore();
  const submit = useAddDokobitCosigner({ onSuccess: closeModal });

  return (
    <div style={submit.isLoading ? disabledSectionStyle : {}}>
      <Stack space={4}>
        <Text font="heading2" text={t('integrations.dokobit.settings.cosigners.modal.header')} />
        <Form onSubmit={(values) => submit.mutateAsync(values)}>
          <Form.TextField
            id="name"
            label={t('integrations.dokobit.settings.cosigners.modal.name.label')}
            validators={['required']}
          />
          <Form.TextField
            label={t('integrations.dokobit.settings.cosigners.modal.email.label')}
            id="email"
            validators={['required', 'email']}
          />
          <Form.TextField
            label={t('integrations.dokobit.settings.cosigners.modal.ssn.label')}
            id="ssn"
            validators={['ssn']}
          />
          <Form.TextField
            label={t('integrations.dokobit.settings.cosigners.modal.phone.label')}
            id="phone"
            validators={['phoneNumber']}
            defaultValue="+354"
          />

          <Form.Actions>
            <Button
              variant="secondary"
              text={t('integrations.dokobit.settings.cosigners.modal.cancel')}
              onClick={closeModal}
            />
            <Form.Submit
              text={t('integrations.dokobit.settings.cosigners.modal.submit')}
              iconLeft={<IconAddPlus />}
            />
          </Form.Actions>
        </Form>
      </Stack>
    </div>
  );
};
